var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_4938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 6.78857V1.28571C16.7143 0.578571 16.1357 0 15.4286 0H12.4714C11.8929 0 11.3271 0.192857 10.8643 0.565714L5.85 4.57714C5.4 4.93714 4.82143 5.14286 4.24286 5.14286H1.28571C0.578571 5.14286 0 5.72143 0 6.42857V11.5714C0 12.2786 0.578571 12.8571 1.28571 12.8571H4.24286C4.82143 12.8571 5.38714 13.05 5.85 13.4229L10.8643 17.4343C11.3143 17.7943 11.8929 18 12.4714 18H15.4286C16.1357 18 16.7143 17.4214 16.7143 16.7143V11.2114C17.4857 10.7614 18 9.95143 18 9C18 8.04857 17.4857 7.22571 16.7143 6.78857ZM4.11429 10.8H2.05714V7.2H4.11429V10.8ZM10.5429 14.5414L7.13571 11.8157C6.84 11.5843 6.51857 11.3914 6.17143 11.2371V6.76286C6.50571 6.60857 6.84 6.42857 7.13571 6.18429L10.5429 3.45857V14.5414ZM14.6571 15.9429H12.6V2.05714H14.6571V15.9429Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_4938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon-notice.8e2fbb49f282baa461505f06b86149e0.svg";
export { ForwardRef as ReactComponent };